import { render, staticRenderFns } from "./CompanyProfileNeedSection.vue?vue&type=template&id=b2efb178&scoped=true"
import script from "./CompanyProfileNeedSection.vue?vue&type=script&lang=js"
export * from "./CompanyProfileNeedSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileNeedSection.vue?vue&type=style&index=0&id=b2efb178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2efb178",
  null
  
)

export default component.exports